import React from "react";
import "./App.css";
import Routes from "./routes";
import { SiteProvider } from "./context";


export default function App() {
  return (
    <div className="page">
      <SiteProvider>
        <Routes />
      </SiteProvider>
    </div>
  );
}